import styled from '@emotion/styled'
import { tokens } from '../../theme.js'
const colors = tokens.colors

export const PageTitle = styled.h1`
  margin: 0;
  font: 700 26px/1.2 ${tokens.fonts.heading};
  color: ${colors.text.heading};
`
export const Subheading = styled.h2`
  margin: 0;
  font: 400 15px/1.4 ${tokens.fonts.heading};
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${colors.text.heading};
`
export const BodyText = styled.p`
  margin: 0;
  font: 400 16px/1.5 ${tokens.fonts.body};
  color: ${colors.text.body};
`
export const BoldBodyText = styled.p`
  margin: 0;
  font: 500 16px/1.5 ${tokens.fonts.body};
  color: ${colors.text.body};
`
export const MedBodyText = styled.p`
  margin: 0;
  font: 400 14px/1.5 ${tokens.fonts.body};
  color: ${colors.text.body};
`
export const BoldMedBodyText = styled.p`
  margin: 0;
  font: 500 14px/1.5 ${tokens.fonts.body};
  color: ${colors.text.body};
`
export const MutedText = styled.p`
  margin: 0;
  font: 400 13px/1.4 ${tokens.fonts.body};
  color: ${colors.text.muted};
`
export const ErrorText = styled.p`
  margin: 5px 0 0;
  font: 400 12px/1.4 ${tokens.fonts.body};
  color: ${colors.error};
`
